import type { SxProps } from "@mui/material";
import { Button } from "@mui/material";
import type { FC, PropsWithChildren, ReactNode } from "react";

interface Props {
  readonly loading: boolean;
  readonly icon: ReactNode;
  readonly variant?: "outlined" | "contained" | "text";
  readonly color?: "primary" | "secondary" | "error" | "inherit";
  readonly sx?: SxProps;
  onDownload: () => Promise<void>;
}

const SingleOptionDownloadButton: FC<PropsWithChildren<Props>> = ({
  loading,
  variant = "outlined",
  color = "secondary",
  icon,
  children,
  sx,
  onDownload,
}) => (
  <Button
    color={color}
    variant={variant}
    startIcon={icon}
    onClick={onDownload}
    loadingPosition="start"
    sx={sx}
    loading={loading}
  >
    {children}
  </Button>
);

export default SingleOptionDownloadButton;
